import { http } from "@/lib/http";
export function fetchTopics() {
  return http.get("/api/topics/get_all").then((res) => res.data);
}
export function addTopic(topic) {
  return http.post("/api/topics/add", { topic }).then((res) => res.data);
}
export async function subscribeFromCsv(csvFileData) {
  const { topics, usersFCMTokens } = await http
    .post("/users/topics/add", { csvFileData })
    .then((res) => res.data);
  return http
    .post("/api/notifications/sub_topic", { usersFCMTokens, topics })
    .then((res) => res.data);
}
